import React, { FunctionComponent } from "react";

const ErrorStatusIcon: FunctionComponent = () => (
    <svg width="75" height="75" viewBox="0 0 75 75" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M49.4375 22.9375L51.5588 25.0588L25.0588 51.5588L22.9375 49.4375L49.4375 22.9375Z"
            fill="#E1251B"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M51.5588 49.4375L49.4375 51.5588L22.9375 25.0588L25.0588 22.9375L51.5588 49.4375Z"
            fill="#E1251B"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M37.5 72C56.5538 72 72 56.5538 72 37.5C72 18.4462 56.5538 3 37.5 3C18.4462 3 3 18.4462 3 37.5C3 56.5538 18.4462 72 37.5 72ZM37.5 75C58.2107 75 75 58.2107 75 37.5C75 16.7893 58.2107 0 37.5 0C16.7893 0 0 16.7893 0 37.5C0 58.2107 16.7893 75 37.5 75Z"
            fill="#E1251B"
        />
    </svg>
);

export default ErrorStatusIcon;
